<template>
  <icon-button v-bind="$attrs" icon="edit" @click="$emit('click')" />
</template>

<script>
import IconButton from './IconButton';

export default {
  name: 'EditButton',
  components: {
    IconButton,
  },
  inheritAttrs: false,
};
</script>
